import Column from '@/components/nav/dropdown/column';
import Content from '@/components/nav/dropdown/content';
import ContentCard from '@/components/nav/dropdown/content-card';
import Link from '@/components/nav/dropdown/link';
import Dropdown from '@/components/nav/dropdown';
import {
  Academy,
  Paper,
  Resources as ResourceIcon,
  Calendar,
  Newspaper,
  Question,
  Write,
} from '@/components/nav/content/icons';

import dxpReport from '@/public/images/nav/dxp-report.png';

export function Resources({ isDesktop }: { isDesktop: boolean }) {
  return (
    <Dropdown>
      <Column label="Resources">
        <Link
          href="/academy"
          title="Academy"
          subTitle="Learn the basics"
          icon={Academy}
        />
        <Link
          href="/blog"
          title="Blog"
          subTitle="Latest updates from GraphCMS"
          icon={Paper}
        />
        <Link
          href="/resources"
          title="Resource Hub"
          subTitle="Curated resources to help you succeed"
          icon={ResourceIcon}
        />
        <Link
          href="/events"
          title="Events"
          subTitle="Come meet us around the world"
          icon={Calendar}
        />
      </Column>
      <Column>
        <Link
          href="/newsroom"
          title="Newsroom"
          subTitle="Latest announcements from the GraphCMS team"
          icon={Newspaper}
        />
        <Link
          href="/faq"
          title="FAQ"
          subTitle="Frequently asked questions from our community"
          icon={Question}
        />
        <Link
          href="/write-for-graphcms"
          title="Write for GraphCMS"
          subTitle="Share your knowledge and help others learn"
          icon={Write}
        />
      </Column>
      {isDesktop && (
        <Content>
          <ContentCard
            href="/blog/how-to-migrate-from-monolith-to-modular-dxp"
            label="Blog"
            image={{
              src: `/images/nav/blog-migrate.svg`,
              blurDataURL: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVQImWNg5lKb33u3IHEFA4M8g4CY+f8H///f/a+uFMEgLubuZdaxe+5/BgZZABbfDnw51OnJAAAAAElFTkSuQmCC`,
            }}
            title="Migrate from a monolith to a modern stack"
          />
          <ContentCard
            href="/resources/dxp-report-2020"
            label="Report"
            image={dxpReport}
            title="Composable architectures for business innovation"
          />
        </Content>
      )}
    </Dropdown>
  );
}
